// extracted by mini-css-extract-plugin
export const box = "VideoSection-module--box--3S7wk";